import { ComponentTooltipHandlerBehavior, Component } from "@mcleod/components";

export class AppComponentTooltipHandlerBehavior extends ComponentTooltipHandlerBehavior {
    protected constructor() {
        super();
    }

    public shouldPreventTooltipDisplay(_component: Component): boolean {
        return true;
    }
}

AppComponentTooltipHandlerBehavior.register();
